<script setup lang="ts">

import { faPaperPlane } from '@fortawesome/pro-regular-svg-icons'

import { AppText } from '@shared/ui/typography'
import { AppIcon } from '@shared/ui/icons'
import { BtnCheckbox, BtnSecondary } from '@shared/ui/buttons'

import DisciplinePaymentLinkField from './DisciplinePaymentLinkField.vue'
import { useDisciplinePaymentShare } from '../model/discipline-payment-share.hook'
import { DisciplinePaymentLinksTab } from '../model/enums'

defineOptions({
  name: 'DisciplinePaymentShare',
})

const {
  refIsPricingTab,
  refLink,
  refIsSending,
  refCanSend,
  canManageOrders,
  senderOptions,
  setTab,
  isSenderChecked,
  toggleSender,
  send,
} = useDisciplinePaymentShare()
</script>

<template>
  <div class="discipline-payment-share">
    <div
      class="discipline-payment-share__tabs"
      role="tablist"
      aria-label="Link to send"
    >
      <button
        type="button"
        role="tab"
        :aria-selected="!refIsPricingTab"
        :class="['discipline-payment-share__tab', { selected: !refIsPricingTab }]"
        @click="setTab(DisciplinePaymentLinksTab.PaymentLink)"
      >
        Send payment link to user
      </button>
      <button
        type="button"
        role="tab"
        :aria-selected="refIsPricingTab"
        :class="['discipline-payment-share__tab', { selected: refIsPricingTab }]"
        :disabled="!canManageOrders"
        @click="setTab(DisciplinePaymentLinksTab.PricingPage)"
      >
        Send pricing page to user
      </button>
    </div>
    <DisciplinePaymentLinkField
      :key="refIsPricingTab ? 'pricing' : 'payment'"
      :label="refIsPricingTab ? 'Pricing page link' : 'Payment link'"
      :link="refLink"
    />
    <div class="discipline-payment-share__senders">
      <AppText
        name="body1-medium"
        :color="refIsSending ? 'slate-500' : 'slate-900'"
      >
        Send payment link via:
      </AppText>
      <BtnCheckbox
        v-for="option in senderOptions"
        :key="option.sender"
        :text="option.label"
        :checked="isSenderChecked(option.sender)"
        :disabled="refIsSending"
        @click="toggleSender(option.sender)"
      />
    </div>
    <div>
      <BtnSecondary
        text="Send link"
        color="black"
        :disabled="!refCanSend"
        @click="send"
      >
        <template #iconLeft>
          <AppIcon :icon="faPaperPlane" />
        </template>
      </BtnSecondary>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./DisciplinePaymentShare.scss" />
